import { useLocalStorage } from '@backoffice-frontend/hooks'
import { Option, Select } from '@moia-dev/pace-web'
import { useTranslation } from 'react-i18next'
import {
  DEFAULT_ORGANIZATION,
  MANUALLY_SELECTED_ORGANIZATION,
} from './constants'
import { useOrganizations } from './useOrganizations'

export const OrganizationSelector = ({
  onOrganizationChange,
}: {
  onOrganizationChange: () => void
}) => {
  const { t } = useTranslation()
  const { organizations } = useOrganizations()
  const [selectedOrganization, setSelectedOrganization] = useLocalStorage(
    MANUALLY_SELECTED_ORGANIZATION,
    DEFAULT_ORGANIZATION,
  )

  const handleOrganizationChange = (value: string) => {
    setSelectedOrganization(value)
    onOrganizationChange()
  }

  const selectedOption = organizations.find(
    org => org.subdomain === selectedOrganization,
  )

  return (
    <Select
      aria-label={t('loginView_organizationSelector')}
      size="compact"
      placeholder={t('loginView_organizationSelector')}
      setSelectedOption={handleOrganizationChange}
      selectedOption={selectedOption?.name ?? ''}
      options={
        <>
          {organizations.map(organization => (
            <Option key={organization.subdomain} value={organization.subdomain}>
              {organization.name}
            </Option>
          ))}
        </>
      }
    />
  )
}
